// Used in grade-assignments.component.ts

import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "error-state-dialog",
    templateUrl: "./error-state-dialog.component.html",
    styleUrls: ["./error-state-dialog.component.scss"],
    standalone: false
})
export class ErrorStateDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ErrorStateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    close(): void {
        this.dialogRef.close(1);
    }
}
